const colors = [
    "#FFA87D",
    "#00B5B8",
    "#FF7588",
    "#16D39A",
    "#6bcafa",
    "#11264F",
    "#EF3F28",
    "#1C7093",
    "#F46A3B",
    "#238B98",
    "#70AEA1",
];

export function Colors(number) { 
    const colors = [];
    for (var i=0;i<number;i++)
        colors.push(Color())
}

export default function Color(index) { 
    if (index === undefined) return colors[Math.floor(Math.floor(colors.length) * Math.random())]
    return colors[index % colors.length]
}